// Safe guard: do not break the entire custom.js if jQuery_T4NT is not ready yet
(function waitForT4JQ(){
  if (window.jQuery_T4NT) {
    jQuery_T4NT(document).ready(function($) {
      $(document).on("variant:change", function(evt, variant) {
        // console.log(variant);
      });
    });
  } else {
    setTimeout(waitForT4JQ, 100);
  }
})();
/* =========================
   MT Add to Cart Button to Cart Icon Animation
========================= */
(function () {
  var style = document.createElement("style");
  style.innerHTML = `
    .mt-flying-cart-icon {
      position: fixed !important;
      z-index: 999999999 !important;
      width: 42px !important;
      height: 42px !important;
      border-radius: 50% !important;
      background: #111 !important;
      color: #fff !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      pointer-events: none !important;
      box-shadow: 0 10px 30px rgba(0,0,0,0.28) !important;
      transition: all 0.8s cubic-bezier(0.22, 1, 0.36, 1) !important;
      opacity: 1 !important;
      transform: scale(1) !important;
    }

    .mt-flying-cart-icon svg {
      width: 22px !important;
      height: 22px !important;
      stroke: currentColor !important;
    }

    .mt-cart-target-pop {
      animation: mtCartTargetPop 0.45s ease !important;
    }

    @keyframes mtCartTargetPop {
      0% { transform: scale(1); }
      50% { transform: scale(1.22); }
      100% { transform: scale(1); }
    }
  `;
  document.head.appendChild(style);

  function isVisible(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function findCartTarget() {
    var selectors = [
      "[data-id='#nt_cart_canvas']",
      ".push_side[data-id='#nt_cart_canvas']",
      "a[href='/cart']",
      "a[href*='/cart']",
      ".cart-icon",
      ".cart_icon",
      ".icon_cart",
      "#cart-icon-bubble"
    ];

    for (var i = 0; i < selectors.length; i++) {
      var items = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < items.length; j++) {
        if (isVisible(items[j])) return items[j];
      }
    }

    return null;
  }

  function createCartIcon() {
    var icon = document.createElement("div");
    icon.className = "mt-flying-cart-icon";
    icon.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="9" cy="21" r="1"></circle>
        <circle cx="20" cy="21" r="1"></circle>
        <path d="M1 1h4l2.5 13.5a2 2 0 0 0 2 1.5h9.8a2 2 0 0 0 2-1.6L23 6H6"></path>
      </svg>
    `;
    return icon;
  }

  function runCartAnimation(button) {
    var buttonRect = button.getBoundingClientRect();
    var cartTarget = findCartTarget();

    var startX = buttonRect.left + buttonRect.width / 2 - 21;
    var startY = buttonRect.top + buttonRect.height / 2 - 21;

    var endX;
    var endY;

    if (cartTarget) {
      var cartRect = cartTarget.getBoundingClientRect();
      endX = cartRect.left + cartRect.width / 2 - 21;
      endY = cartRect.top + cartRect.height / 2 - 21;
    } else {
      endX = window.innerWidth - 65;
      endY = 25;
    }

    var flyingIcon = createCartIcon();

    flyingIcon.style.left = startX + "px";
    flyingIcon.style.top = startY + "px";

    document.body.appendChild(flyingIcon);

    setTimeout(function () {
      flyingIcon.style.left = endX + "px";
      flyingIcon.style.top = endY + "px";
      flyingIcon.style.opacity = "0";
      flyingIcon.style.transform = "scale(0.45)";
    }, 40);

    setTimeout(function () {
      flyingIcon.remove();

      if (cartTarget) {
        cartTarget.classList.add("mt-cart-target-pop");

        setTimeout(function () {
          cartTarget.classList.remove("mt-cart-target-pop");
        }, 450);
      }
    }, 900);
  }

  document.addEventListener("click", function (event) {
    var addButton = event.target.closest &&
      event.target.closest(
        "button[name='add'], input[name='add'], button[type='submit'][name='add'], form[action*='/cart/add'] button[type='submit']"
      );

    if (!addButton) return;

    setTimeout(function () {
      runCartAnimation(addButton);
    }, 250);
  }, true);
})();
/* =========================
   Swatch Click Handler
========================= */
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('.product-color-swatches .swatch');
    if(!btn) return;

    // mark selected for accessibility & visuals
    var all = document.querySelectorAll('.product-color-swatches .swatch');
    all.forEach(function(s){ s.setAttribute('aria-checked','false'); });
    btn.setAttribute('aria-checked','true');

    var variantId = btn.getAttribute('data-variant-id');
    if(!variantId) return;

    // 1) Try standard select element
    var select = document.querySelector('form[action*="/cart"] select[name="id"], select[name="id"]');
    if(select) {
      select.value = variantId;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    // 2) Try radio inputs
    var variantInput = document.querySelector('input[name="id"][value="'+variantId+'"]');
    if(variantInput) {
      variantInput.checked = true;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    // 3) Try element click fallback
    var el = document.querySelector('[data-variant-id="'+variantId+'"]');
    if(el) {
      el.click();
      return;
    }
  });

  // Optional: set initial selected swatch based on current variant
  function markInitialSwatch() {
    var currentVariantInput = document.querySelector('form[action*="/cart"] select[name="id"], select[name="id"], input[name="id"]:checked');
    var activeId = currentVariantInput ? (currentVariantInput.value || currentVariantInput.getAttribute('value')) : null;
    if(!activeId) return;

    var activeBtn = document.querySelector('.product-color-swatches .swatch[data-variant-id="'+activeId+'"]');
    if(activeBtn) activeBtn.setAttribute('aria-checked','true');
  }
  markInitialSwatch();
});

/* =========================
   MT Desktop Filter Drawer
   (KEEP ONLY ONE VERSION)
========================= */
(function () {
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }

  function initDrawer() {
    var root = document.documentElement;
    var drawerRoot = qs('#mtSidebarDrawer');
    if (!drawerRoot) return;

    function setExpanded(val) {
      document.querySelectorAll('[aria-controls="mtSidebarDrawer"]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', val ? 'true' : 'false');
      });
    }

    function openDrawer() {
      root.classList.add('mt-filter-open');
      drawerRoot.setAttribute('aria-hidden', 'false');
      setExpanded(true);
    }

    function closeDrawer() {
      root.classList.remove('mt-filter-open');
      drawerRoot.setAttribute('aria-hidden', 'true');
      setExpanded(false);
    }

    // Use CAPTURE to beat theme handlers that stop propagation
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[aria-controls="mtSidebarDrawer"]');
      if (trigger) {
        e.preventDefault();
        openDrawer();
        return;
      }

      if (e.target.closest && (e.target.closest('.mt-sidebar-close') || e.target.closest('.mt-sidebar-overlay'))) {
        e.preventDefault();
        closeDrawer();
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawer);
  } else {
    initDrawer();
  }
})();

/* =========================
   MT Cart Subtotal MRP to RRP - Quantity Safe
   Only changes mini cart subtotal, not product MRP
========================= */
(function () {
  function mtSubtotalRRP() {
    var subtotalPrice = document.querySelector(
      '#nt_cart_canvas .mini_cart_footer .cart_tot_price'
    );

    if (!subtotalPrice) return;

    subtotalPrice.textContent = subtotalPrice.textContent.replace(/\bMRP\b/g, 'RRP');
  }

  function mtRunSubtotalRRP() {
    mtSubtotalRRP();

    setTimeout(mtSubtotalRRP, 100);
    setTimeout(mtSubtotalRRP, 300);
    setTimeout(mtSubtotalRRP, 700);
    setTimeout(mtSubtotalRRP, 1200);
    setTimeout(mtSubtotalRRP, 2000);
  }

  // Page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mtRunSubtotalRRP);
  } else {
    mtRunSubtotalRRP();
  }

  window.addEventListener('load', mtRunSubtotalRRP);

  // Cart clicks: open cart, add product, plus/minus, remove item
  document.addEventListener('click', function (event) {
    var target = event.target;

    if (
      target.closest('#nt_cart_canvas') ||
      target.closest("[data-id='#nt_cart_canvas']") ||
      target.closest(".push_side[data-id='#nt_cart_canvas']") ||
      target.closest("a[href='/cart']") ||
      target.closest("a[href*='/cart']") ||
      target.closest("button[name='add']") ||
      target.closest("input[name='add']") ||
      target.closest("form[action*='/cart/add'] button[type='submit']")
    ) {
      mtRunSubtotalRRP();
    }
  }, true);

  // Quantity input change
  document.addEventListener('change', function (event) {
    if (
      event.target.closest('#nt_cart_canvas') ||
      event.target.name === 'updates[]' ||
      event.target.name === 'quantity'
    ) {
      mtRunSubtotalRRP();
    }
  }, true);

  // Keyup for manual quantity typing
  document.addEventListener('keyup', function (event) {
    if (
      event.target.closest('#nt_cart_canvas') ||
      event.target.name === 'updates[]' ||
      event.target.name === 'quantity'
    ) {
      mtRunSubtotalRRP();
    }
  }, true);

  // Theme/cart custom events
  document.addEventListener('cart:updated', mtRunSubtotalRRP);
  document.addEventListener('ajaxCart:updated', mtRunSubtotalRRP);
  document.addEventListener('cart.requestComplete', mtRunSubtotalRRP);
  document.addEventListener('cart:refresh', mtRunSubtotalRRP);

  // After AJAX/fetch updates
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function () {
      return originalFetch.apply(this, arguments).then(function (response) {
        mtRunSubtotalRRP();
        return response;
      });
    };
  }

  // After old XMLHttpRequest AJAX updates
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function () {
    this.addEventListener('loadend', function () {
      mtRunSubtotalRRP();
    });
    return originalOpen.apply(this, arguments);
  };
})();